<template>
  <div
    class="social-marketing-studio-info"
    :class="{
      dark: color === 'dark',
      light: color === 'light',
      'dark-opacity': color === 'dark-opacity',
    }"
  >
    <img
      class="profile-photo"
      v-if="showProfilePhoto && profilePhoto"
      :src="profilePhoto"
    />
    <span class="flex-1 text-truncate mr-5">
      <small
        class="studio-url"
        :class="isSmallStudioUrl ? 'studio-url--small' : ''"
        v-if="studioUrl"
      >
        {{ studioUrl }}
      </small>
    </span>
    <span v-if="showMarvelousIcon" class="hm-logo-wrap">
      <img class="hm-logo" :src="marvelousIcon" />
    </span>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'SocialMarketingStudioInfo',
  props: {
    showProfilePhoto: {
      type: Boolean,
      default: true,
    },
    showMarvelousIcon: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'dark',
    },
    studioUrl: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
    }),
    profilePhoto() {
      return this.teacher?.profile_photo?.thumbnail;
    },
    marvelousIcon() {
      return this.color === 'dark'
        ? '/assets/images/marketing-hey-marvelous-icon-dark.png'
        : '/assets/images/marketing-hey-marvelous-icon-white.png';
    },
    isSmallStudioUrl() {
      return this.studioUrl?.length > 34;
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.social-marketing-studio-info {
  display: flex;
  align-items: center;
  height: 24px * $social-marketing-card-factor;
  text-transform: uppercase;
  &.light {
    color: white;
  }
  &.dark {
    color: $charcoal;
  }
  &.dark-opacity {
    color: rgba($charcoal, 0.5);
  }
}

.profile-photo {
  width: 24px * $social-marketing-card-factor;
  height: 24px * $social-marketing-card-factor;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px * $social-marketing-card-factor;
}

.hm-logo {
  height: 14px * $social-marketing-card-factor;
}

.studio-url {
  font-size: 10px * $social-marketing-card-factor;
  &--small {
    font-size: 8px * $social-marketing-card-factor;
  }
}
</style>
